import { NavItem } from "./nav-item/nav-item";

export const navItems: NavItem[] = [
  {
    navCap: "Home",
  },
  {
    displayName: "Dashboard",
    iconName: "home",
    route: "/dashboard",
  },
  {
    navCap: "Maticas",
  },
  {
    displayName: "Pending Orders",
    iconName: "receipt",
    route: "/pending_orders",
  },
  {
    displayName: "Pull Sheet",
    iconName: "clipboard-text",
    route: "/pull_sheet",
  },
  {
    displayName: "Bill of Landing",
    iconName: "receipt-dollar",
    route: "/bill_of_landing",
  },
  {
    displayName: "Sale Orders",
    iconName: "shopping-cart-share",
    route: "/sale-orders",
  },

  // {
  //   displayName: "Orders",
  //   iconName: "pin-invoke",
  //   route: "/orders",
  // },
];
